export var milkmanCities = [
	['20090','Assago'],
	['20021','Bollate'],
	['20091','Bresso'],
	['20090','Buccinasco'],
	['20061','Carugate'],
	['20063','Cernusco Sul Naviglio'],
	['20090','Cesano Boscone'],
	['20092','Cinisello Balsamo'],
	['20093','Cologno Monzese'],
	['20032','Cormano'],
	['20094','Corsico'],
	['20095','Cusano Milanino'],
	['20064','Gorgonzola'],
	['20066','Melzo'],
	['20121','Milano'],
	['20122','Milano'],
	['20123','Milano'],
	['20124','Milano'],
	['20125','Milano'],
	['20126','Milano'],
	['20127','Milano'],
	['20128','Milano'],
	['20129','Milano'],
	['20131','Milano'],
	['20132','Milano'],
	['20133','Milano'],
	['20134','Milano'],
	['20135','Milano'],
	['20136','Milano'],
	['20137','Milano'],
	['20138','Milano'],
	['20139','Milano'],
	['20141','Milano'],
	['20142','Milano'],
	['20143','Milano'],
	['20144','Milano'],
	['20145','Milano'],
	['20146','Milano'],
	['20147','Milano'],
	['20148','Milano'],
	['20149','Milano'],
	['20151','Milano'],
	['20152','Milano'],
	['20153','Milano'],
	['20154','Milano'],
	['20155','Milano'],
	['20156','Milano'],
	['20157','Milano'],
	['20158','Milano'],
	['20159','Milano'],
	['20161','Milano'],
	['20026','Novate Milanese'],
	['20090','Opera'],
	['20037','Paderno Dugnano'],
	['20016','Pero'],
	['20068','Peschiera Borromeo'],
	['20096','Pioltello'],
	['20017','Rho'],
	['20090','Rodano'],
	['20089','Rozzano'],
	['20097','San Donato Milanese'],
	['20090','Segrate'],
	['20030','Senago'],
	['20099','Sesto San Giovanni'],
	['20090','Settala'],
	['20019','Settimo Milanese'],
	['20090','Trezzano Sul Naviglio'],
	['20090','Vimodrone'],
	['20021','Baranzate'],
	['20864','Agrate Brianza'],
	['20861','Brugherio'],
	['20863','Concorezzo'],
	['20900','Monza'],
	['20835','Muggiò'],
	['20834','Nova Milanese'],
	['20162','Milano'],
	['20090','Cusago'],
	['20090','Pantigliate'],
	['20090','Pieve Emanuele'],
	['20068','Bettola-Zeloforamagno'],
	['20100','Milano'],
	['20900','Boscherona'],
	['20861','Increa'],
	['20861','San Damiano'],
	['20097','San Donato'],
	['20098','San Giuliano Milanese'],
	["10023","Chieri"],
	["10024","Moncalieri"],
	["10025","Pino Torinese"],
	["10028","Trofarello"],
	["10036","Settimo Torinese"],
	["10042","Nichelino"],
	["10043","Orbassano"],
	["10044","Pianezza"],
	["10048","Vinovo"],
	["10071","Borgaro Torinese"],
	["10078","Venaria Reale"],
	["10121","Torino"],
	["10122","Torino"],
	["10123","Torino"],
	["10124","Torino"],
	["10125","Torino"],
	["10126","Torino"],
	["10127","Torino"],
	["10128","Torino"],
	["10129","Torino"],
	["10130","Torino"],
	["10131","Torino"],
	["10132","Torino"],
	["10133","Torino"],
	["10134","Torino"],
	["10135","Torino"],
	["10136","Torino"],
	["10137","Torino"],
	["10138","Torino"],
	["10139","Torino"],
	["10140","Torino"],
	["10141","Torino"],
	["10142","Torino"],
	["10143","Torino"],
	["10144","Torino"],
	["10145","Torino"],
	["10146","Torino"],
	["10147","Torino"],
	["10148","Torino"],
	["10149","Torino"],
	["10150","Torino"],
	["10151","Torino"],
	["10152","Torino"],
	["10153","Torino"],
	["10154","Torino"],
	["10155","Torino"],
	["10156","Torino"],
	["10091","Alpignano"],
	["10092","Beinasco"],
	["10093","Collegno"],
	["10095","Grugliasco"],
	["10098","Rivoli"],
	["10099","San Mauro Torinese"],
	["00120","Roma"],
	["00152","Roma"],
	["00153","Roma"],
	["00161","Roma"],
	["00162","Roma"],
	["00184","Roma"],
	["00185","Roma"],
	["00186","Roma"],
	["00187","Roma"],
	["00192","Roma"],
	["00193","Roma"],
	["00195","Roma"],
	["00196","Roma"],
	["00197","Roma"],
	["00198","Roma"],
	["00199","Roma"],
	["00136","Roma"],
	["00141","Roma"],
	["00145","Roma"],
	["00146","Roma"],
	["00147","Roma"],
	["00149","Roma"],
	["00151","Roma"],
	["00154","Roma"],
	["00157","Roma"],
	["00158","Roma"],
	["00159","Roma"],
	["00164","Roma"],
	["00165","Roma"],
	["00167","Roma"],
	["00176","Roma"],
	["00179","Roma"],
	["00181","Roma"],
	["00182","Roma"],
	["00183","Roma"],
	["00194","Roma"],
	["00135","Roma"],
	["00137","Roma"],
	["00138","Roma"],
	["00139","Roma"],
	["00142","Roma"],
	["00143","Roma"],
	["00144","Roma"],
	["00148","Roma"],
	["00155","Roma"],
	["00156","Roma"],
	["00163","Roma"],
	["00166","Roma"],
	["00168","Roma"],
	["00169","Roma"],
	["00171","Roma"],
	["00172","Roma"],
	["00173","Roma"],
	["00174","Roma"],
	["00175","Roma"],
	["00177","Roma"],
	["00178","Roma"],
	["00188","Roma"],
	["00189","Roma"],
	["00191","Roma"]
]

export var milkmanCitiesNoTimeRange = [
	['37121', 'Verona'],
	['37122', 'Verona'],
	['37123', 'Verona'],
	['37126', 'Verona'],
	['37129', 'Verona'],
	['37131', 'Verona'],
	['37132', 'Verona'],
	['37133', 'Verona'],
	['37134', 'Verona'],
	['37135', 'Verona'],
	['37136', 'Verona'],
	['37138', 'Verona'],
	['37057', 'San Giovanni Lupatoto'],
	['21052', 'Busto Arsizio'],
	['21013', 'Gallarate'],
	['21047', 'Saronno'],
	['21057', 'Olgiate Olona'],
	['21042', 'Caronno Pertusella'],
	['21012', 'Cassano Magnago'],
	['21054', 'Fagnano Olona'],
	['21058', 'Solbiate Olona'],
	['20024', 'Garbagnate Milanese'],
	['20027', 'Rescaldina'],
	['20025', 'Legnano'],
	['20020', 'Magnago'],
	['20020', 'Arconate'],
	['20020', 'Busto Garolfo'],
	['20020', 'Cesate'],
	['20020', 'Dairago'],
	['20020', 'Lainate'],
	['20020', 'Vanzaghello'],
	['20020', 'Villa Cortese'],
	['20020', 'Robecchetto Con Induno'],
	['20020', 'Solaro'],
	['20020', 'Nosate'],
	['20010', 'Canegrate'],
	['20010', 'San Giorgio Su Legnano'],
	['20010', 'Buscate'],
	['20010', 'Bernate Ticino'],
	['20010', 'Boffalora Sopra Ticino'],
	['20010', 'Marcallo Con Casone'],
	['20010', 'Mesero'],
	['20010', 'Inveruno'],
	['20010', 'Casorezzo'],
	['20010', 'Ossona'],
	['20010', 'Santo Stefano Ticino'],
	['20010', 'Arluno'],
	['20010', 'Vittuone'],
	['20010', 'Pregnana Milanese'],
	['20010', 'Cornaredo'],
	['20010', 'Bareggio'],
	['20010', 'Pogliano Milanese'],
	['20010', 'Vanzago'],
	['20015', 'Parabiago'],
	['20014', 'Nerviano'],
	['25124', 'Brescia'],
	['25121', 'Brescia'],
	['25122', 'Brescia'],
	['25125', 'Brescia'],
	['25126', 'Brescia'],
	['25127', 'Brescia'],
	['25128', 'Brescia']
]

